import { Component, Input, OnChanges } from '@angular/core';
import * as Highcharts from 'highcharts';
import { HighchartsChartModule } from 'highcharts-angular';

export interface IPorcionTortaEmergencias {
  name: string;
  y: number; // cantidad
  color?: string;
}

/**
 * Torta del resumen del mapa, dentro del panel flotante: misma presentación
 * que la de luminarias (fondo transparente y leyenda compacta abajo).
 */
@Component({
  selector: 'app-pie-chart-emergencias',
  template: `
    <highcharts-chart
      [Highcharts]="Highcharts"
      [options]="chartOptions"
      [style]="chartStyle"
    ></highcharts-chart>
  `,
  styles: [':host { display: block; width: auto; height: auto; }'],
  imports: [HighchartsChartModule],
})
export class PieChartEmergenciasComponent implements OnChanges {
  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {};

  @Input() datos: IPorcionTortaEmergencias[] = [];
  @Input() chartStyle = 'width: 100%; height: 240px; display: block';

  ngOnChanges(): void {
    const total = this.datos.reduce((acc, d) => acc + (d.y || 0), 0);
    const seriesData = this.datos
      .filter((d) => d.y > 0)
      .map((d) => ({
        name: d.name,
        color: d.color,
        y: total > 0 ? +((d.y / total) * 100).toFixed(1) : 0,
        cantidad: d.y,
      }));

    this.chartOptions = {
      chart: {
        type: 'pie',
        backgroundColor: 'transparent',
        spacing: [0, 0, 0, 0],
        margin: [0, 0, 0, 0],
        style: { color: 'var(--fg-grafico)' },
      },
      // Total en el centro de la dona
      title: {
        text: total.toLocaleString('es-AR'),
        verticalAlign: 'middle',
        floating: true,
        // Compensa la línea de base del texto: así queda en el centro del hueco
        y: 14,
        style: {
          color: 'var(--text-color)',
          fontSize: '16px',
          fontWeight: '600',
        },
      },
      credits: { enabled: false },
      plotOptions: {
        pie: {
          size: '100%',
          innerSize: '62%',
          // Sin reserva para porciones separadas: la dona usa todo el alto
          slicedOffset: 0,
          center: ['50%', '50%'],
          // El borde de las porciones toma el fondo del panel
          // Borde con el texto atenuado: la porción "Negro" se distingue
          // también sobre el fondo oscuro
          borderColor: 'var(--muted-text)',
          dataLabels: { enabled: false },
          borderWidth: 1,
        },
      },
      tooltip: {
        pointFormatter: function (this: any) {
          const pct = (this.y ?? 0).toLocaleString('es-AR', {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
          });
          return `<span style="color:${this.color}">${this.name}</span>: <b>${this.options.cantidad}</b> (${pct} %)<br/>`;
        },
      },
      // Sin leyenda: los chips de Estados/Código del panel ya muestran
      // nombres, colores y cantidades. El detalle va en el tooltip.
      legend: { enabled: false },
      exporting: { enabled: false },
      series: [
        {
          name: 'Emergencias',
          colorByPoint: true,
          type: 'pie',
          data: seriesData,
        } as Highcharts.SeriesPieOptions,
      ],
    };
  }
}
